import pageSeo from "@/config/page-seo.json";

const SITE = "https://www.cloudeffective.cn";

/** 生成标准文章地址；调用方应传入接口提供的数字 ID。 */
export const articlePath = (id) => "/news/" + encodeURIComponent(String(id));
export const articleLocation = (id) => ({ name: "newsArticle", params: { id: String(id) } });

/** 创建或更新元信息，兼容缺少对应标签的错误页和旧部署模板。 */
function setMeta(attribute, key, value) {
  let element = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value || "");
}

/** 同步浏览器标题、描述与分享标签；不会把上一页面的描述留在新路由中。 */
export function updatePageMeta({ title = "", description = "", keywords = title } = {}) {
  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "keywords", keywords);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
}

/**
 * 标记客户端已确认不存在的页面；真实 HTTP 404 仍由服务器返回。
 * 离开错误页时只移除本模块创建的 robots 标签，保留部署方设置的其他规则。
 */
export function setPageNoindex(noindex) {
  let robots = document.querySelector('meta[name="robots"][data-route-seo]');
  if (noindex && !robots) {
    robots = document.createElement("meta");
    robots.name = "robots";
    robots.setAttribute("data-route-seo", "");
    document.head.appendChild(robots);
  }
  if (noindex) {
    robots.content = "noindex, follow";
    document.querySelectorAll('link[rel="canonical"]').forEach((tag) => tag.remove());
    document.querySelectorAll('meta[property="og:url"]').forEach((tag) => tag.remove());
  } else if (robots) {
    robots.remove();
  }
}

/** 同步标准地址和固定栏目的完整元信息；动态正文加载后由详情组件补齐。 */
export function updateRouteSeo(route) {
  const noindex = Boolean(route.meta && route.meta.noindex);
  setPageNoindex(noindex);
  if (noindex) {
    updatePageMeta({ title: "页面不存在-云效科技", description: "该页面不存在或已下线，请返回首页或浏览客户案例。" });
    return;
  }

  const pathname = route.name === "newsArticle" ? articlePath(route.params.id) : route.path;
  const normalizedPath = pathname === "/" ? "/" : pathname.replace(/\/$/, "");
  const canonicalUrl = SITE + normalizedPath;
  let canonical = document.querySelector('link[rel="canonical"]');
  const samePage = canonical && canonical.href === canonicalUrl;
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  canonical.href = canonicalUrl;
  setMeta("property", "og:url", canonicalUrl);
  const metadata = pageSeo[normalizedPath];
  if (metadata) {
    updatePageMeta(metadata);
  } else if (!samePage) {
    // 首次访问保留构建时的详情元信息；站内切换时清除旧详情，等待接口或组件补齐。
    updatePageMeta({ title: (route.meta && route.meta.title) || "云效科技" });
  }
}
